import { AgxRadioGroup, AgxSpacer } from '@urbanx/agx.ui-components2'

interface ContractVersionStepProps {
  finalEnabled: boolean
  isFinalSelected: boolean
  onSelectFinal: (isFinal: boolean) => void
}

const ContractVersionStep = ({
  finalEnabled,
  isFinalSelected,
  onSelectFinal,
}: ContractVersionStepProps) => (
  <AgxSpacer direction="vertical" gap="spacing-lg" fill>
    <AgxRadioGroup
      id="contractVersion"
      layout="stacked"
      options={[
        { label: 'Draft Contract', value: 'draft' },
        {
          label: 'Final Contract',
          value: 'final',
          disabled: !finalEnabled,
          hint: !finalEnabled ? 'Compliance incomplete' : undefined,
        },
      ]}
      value={isFinalSelected ? 'final' : 'draft'}
      onChange={(value) => {
        onSelectFinal(value === 'final')
      }}
    />
  </AgxSpacer>
)

export default ContractVersionStep
